module.exports = __webpack_public_path__ + "static/media/gongzhongdagang1.faf0e37c.png";